import { useBlockProps } from "@wordpress/block-editor";
import '../tw_style.css';

const Edit = (props) => {
	return (
			<div {...useBlockProps({ className: "cg_edit_gallery_block_container" })}>
				<h2 className="text-white">Gallery View</h2>
			</div>
	);
};

export default Edit;
